"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DOCUMENTS = void 0;
const client_1 = require("@apollo/client");
const __queries__1 = require("../../../DocumentUploads/__queries__");
exports.GET_DOCUMENTS = (0, client_1.gql) `
  query getDocumentsForProperty($propertyId: ID!, $isPublic: Boolean!) {
    property(propertyId: $propertyId) {
      id
      documentUploads(filterProcessing: false) {
        ...DocumentUploadDataFragment

        elevationCertificate {
          id
        }

        certificateUpload {
          id
          status
        }
      }
    }
  }

  ${__queries__1.DOCUMENT_UPLOAD_DATA_FRAGMENT}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0RG9jdW1lbnRzRm9yUHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL0FkZHJlc3NQYW5lbC9Eb2N1bWVudFVwbG9hZHMvX19xdWVyaWVzX18vZ2V0RG9jdW1lbnRzRm9yUHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkNBQXFDO0FBQ3JDLHFFQUFxRjtBQUV4RSxRQUFBLGFBQWEsR0FBRyxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQW1CNUIsMENBQTZCO0NBQ2hDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBncWwgfSBmcm9tIFwiQGFwb2xsby9jbGllbnRcIjtcbmltcG9ydCB7IERPQ1VNRU5UX1VQTE9BRF9EQVRBX0ZSQUdNRU5UIH0gZnJvbSBcIi4uLy4uLy4uL0RvY3VtZW50VXBsb2Fkcy9fX3F1ZXJpZXNfX1wiO1xuXG5leHBvcnQgY29uc3QgR0VUX0RPQ1VNRU5UUyA9IGdxbGBcbiAgcXVlcnkgZ2V0RG9jdW1lbnRzRm9yUHJvcGVydHkoJHByb3BlcnR5SWQ6IElEISwgJGlzUHVibGljOiBCb29sZWFuISkge1xuICAgIHByb3BlcnR5KHByb3BlcnR5SWQ6ICRwcm9wZXJ0eUlkKSB7XG4gICAgICBpZFxuICAgICAgZG9jdW1lbnRVcGxvYWRzKGZpbHRlclByb2Nlc3Npbmc6IGZhbHNlKSB7XG4gICAgICAgIC4uLkRvY3VtZW50VXBsb2FkRGF0YUZyYWdtZW50XG5cbiAgICAgICAgZWxldmF0aW9uQ2VydGlmaWNhdGUge1xuICAgICAgICAgIGlkXG4gICAgICAgIH1cblxuICAgICAgICBjZXJ0aWZpY2F0ZVVwbG9hZCB7XG4gICAgICAgICAgaWRcbiAgICAgICAgICBzdGF0dXNcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gICR7RE9DVU1FTlRfVVBMT0FEX0RBVEFfRlJBR01FTlR9XG5gO1xuIl19